import unlockedFeaturesDataset from "../datasets/unlocked_features_dataset";

export const determineNbrUnlockedLevels = (featureName) => {
    let nbrLevelsArr = [];
    let saveFeatureName = "";
    let levelCount = 0;
    let unlockedFeaturesList = [];
    let levelObj = {};
    if (featureName){
        unlockedFeaturesList = unlockedFeaturesDataset.filter(elem => elem.featureName === featureName);
        levelCount = unlockedFeaturesList.length;
        levelObj = {featureName: featureName, nbrLevels: levelCount}
        nbrLevelsArr.push(levelObj);
    }else{
        for (let i=0; i<unlockedFeaturesDataset.length; i++){
            const feature = unlockedFeaturesDataset[i];
            if (feature.featureName !== saveFeatureName){
                if (saveFeatureName !== ""){
                    levelObj = {featureName: saveFeatureName, nbrLevels: levelCount};
                    nbrLevelsArr.push(levelObj);
                }
                saveFeatureName = feature.featureName;
                levelCount = 0;
            }
            levelCount += 1;
        }
        levelObj = {featureName: saveFeatureName, nbrLevels: levelCount};
        nbrLevelsArr.push(levelObj);
    }
    return nbrLevelsArr;
}
export default determineNbrUnlockedLevels;